import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import { startThema } from './lib/thema'
import './styles/theme.css'
import './styles/app.css'
import './styles/it.css'

/* Het thema vóór de eerste render, zodat er niet eerst iets donkers staat
   dat daarna licht wordt. */
startThema()

const wortel = document.getElementById('wortel')
if (!wortel) throw new Error('Het element #wortel staat niet in index.html')

createRoot(wortel).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
